<div class="gap-medpace flex flex-col *:grid *:grid-cols-3 *:gap-medpace">
    <div>
        <div>
            <h5>Receipt Date</h5>
            <span>{{ expense().timestamp | dateFormat: undefined : 'local' | uppercase }} </span>
        </div>
    </div>
    <div>
        <div>
            <h5>Requested ({{ expense().currency }})</h5>
            <span>{{ (expense().amount | number: '1.2-2' : 'en-US') ?? 'Unspecified' }}</span>
        </div>
        @let elevatedAccess = elevatedAccess$ | async;
        @let isInProcessOrHigher = isInProcessOrHigher$ | async;
        @if (isInProcessOrHigher === true) {
            <div>
                <!-- Authorized in local currency can be viewed by CRC -->
                <h5>Authorized ({{ expense().currency }})</h5>
                <span>{{ (expense().authorizedAmount | number: '1.2-2' : 'en-US') ?? 'Unspecified' }}</span>
            </div>
        }
    </div>
</div>

@if (isInProcessOrHigher === true && elevatedAccess === true) {
    <div class="flex flex-row gap-medpace pt-medpace">
        @if (authorizedAmountPatientsCurrencyChip()) {
            <mds-chip
                [chips]="authorizedAmountPatientsCurrencyChip()"
                [chipListType]="'basic'"
                [multiple]="true"
            ></mds-chip>
        }
        @if (authorizedAmountUSDChip()) {
            <mds-chip [chips]="authorizedAmountUSDChip()" [chipListType]="'basic'" [multiple]="true"></mds-chip>
        }
    </div>
}

@if (expense().attachmentId) {
    <div class="grid mt-medpace">
        <mds-divider />
        <a class="mt-medpace" (click)="downloadFile()">Download File</a>
    </div>
}
